import { render, staticRenderFns } from "./DesktopSideMenuLastActiveLesson.vue?vue&type=template&id=c95e2a00&scoped=true&"
import script from "./DesktopSideMenuLastActiveLesson.vue?vue&type=script&lang=js&"
export * from "./DesktopSideMenuLastActiveLesson.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSideMenuLastActiveLesson.vue?vue&type=style&index=0&id=c95e2a00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e2a00",
  null
  
)

export default component.exports